import { render, staticRenderFns } from "./TableGroups.vue?vue&type=template&id=2067f85a&scoped=true"
import script from "./TableGroups.js?vue&type=script&lang=js&external"
export * from "./TableGroups.js?vue&type=script&lang=js&external"
import style0 from "./TableGroups.vue?vue&type=style&index=0&id=2067f85a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2067f85a",
  null
  
)

export default component.exports